import React from 'react';
import { Users, CreditCard, Calendar, Megaphone, Heart, UserCheck, Package, BarChart, Globe } from 'lucide-react';

const features = [
  { icon: Users, title: 'Smart CRM', description: 'Track every customer interaction and build lasting relationships automatically' },
  { icon: CreditCard, title: 'Integrated POS', description: 'Process payments, manage inventory, and track sales seamlessly' },
  { icon: Calendar, title: 'Online Bookings', description: '24/7 booking system that eliminates scheduling conflicts and no-shows' },
  { icon: Megaphone, title: 'Marketing & Campaigns', description: 'Automated email and SMS campaigns that bring customers back' },
  { icon: Heart, title: 'Loyalty & Retention', description: 'Reward programs that turn one-time visitors into lifetime clients' },
  { icon: UserCheck, title: 'Staff & Attendance', description: 'Streamlined staff management with automated scheduling and tracking' },
  { icon: Package, title: 'Inventory & Expenses', description: 'Never run out of products again with smart inventory management' },
  { icon: BarChart, title: 'Reports & Insights', description: 'Real-time analytics that help you make profitable decisions' },
  { icon: Globe, title: 'Website & Online Presence', description: 'Professional website and social media management tools' }
];

const Solution: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Introducing Zylu: Your Salon's Complete Autopilot Solution
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto mb-8">
            Everything you need to run a successful salon business, integrated into one powerful platform. 
            Stop juggling multiple tools and start growing your business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div key={index} className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-red-200">
                <div className="flex items-center mb-6">
                  <div className="bg-red-100 p-3 rounded-lg mr-4">
                    <IconComponent className="h-8 w-8 text-red-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{feature.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        <div className="bg-red-50 rounded-2xl p-8 text-center">
          <h3 className="text-3xl font-bold text-black mb-4">
            All Features Work Together Seamlessly
          </h3>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Unlike other solutions that force you to use multiple disconnected tools, Zylu is designed 
            as one integrated system. When a customer books online, their information automatically flows 
            through your CRM, POS, marketing campaigns, and reporting dashboards.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Solution;